import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=87437d26"
import script from "./app-main.vue?vue&type=script&lang=js"
export * from "./app-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports